import { Fragment, ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const Users = (): ReactElement => {
  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};
export default Users;
